import classNames from 'classnames';
import type { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
    className?: string | undefined;
}

const ModalBody = ({ children, className }: Props) => (
    <main className={classNames(className, 'modal-body')} data-testid="dialog-body">
        {children}
    </main>
);

export default ModalBody;
